/**
 * Utility functions for file downloads
 */

/**
 * Format product title for filename
 * @param {string} title - Product title
 * @returns {string} - Formatted filename
 */
export const formatProductFilename = (title) => {
  return title.replace(/\s+/g, '-').toLowerCase();
};

/**
 * Download file from blob
 * @param {Blob} blob - File blob
 * @param {string} filename - Desired filename
 */
export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  
  // Trigger download
  document.body.appendChild(link);
  link.click();
  
  // Clean up
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

/**
 * Download file from URL
 * @param {string} url - File URL
 * @param {string} filename - Desired filename
 * @returns {Promise} - Download promise
 */
export const downloadFile = async (url, filename) => {
  try {
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`Download failed: ${response.status}`);
    }
    
    const blob = await response.blob();
    downloadBlob(blob, filename);
    
    return { success: true };
  } catch (error) {
    console.error('Download error:', error);
    throw error;
  }
};
